"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var moment_1 = require("moment");
function PARAMS_TOUCHED(state, newV) {
    if (newV === undefined) {
        state.paramsTouched = true;
    }
    else {
        state.paramsTouched = newV;
    }
}
exports.PARAMS_TOUCHED = PARAMS_TOUCHED;
function SEARCH_BUTTON_TOUCHED(state, newV) {
    state.searchButtonTouched = newV;
}
exports.SEARCH_BUTTON_TOUCHED = SEARCH_BUTTON_TOUCHED;
function SET_BACKGROUND_IMAGES(state, data) {
    if (state.backgroundImages.length) {
        // we dont really want to override our background images so
        // sort order stays the same and UI does not flicker
        // (ssr to browser)
        return;
    }
    state.backgroundImages = lodash_1.reduce(lodash_1.range(lodash_1.random(2, 10)), function (data) {
        return lodash_1.shuffle(data);
    }, data);
}
exports.SET_BACKGROUND_IMAGES = SET_BACKGROUND_IMAGES;
function SET_REGIONS(state, data) {
    state.availableRegions = data;
}
exports.SET_REGIONS = SET_REGIONS;
function SET_SHIP_LIST(state, data) {
    state.availableShips = data;
}
exports.SET_SHIP_LIST = SET_SHIP_LIST;
function SET_PARAM(state, _a) {
    var key = _a.key, value = _a.value;
    state.params[key] = value;
}
exports.SET_PARAM = SET_PARAM;
function SET_RESULTS(state, routes) {
    var regionIDs = [];
    var airportIDs = [];
    var durationDays = [];
    var shipNames = [];
    lodash_1.map(routes, function (route) {
        route.cruises = lodash_1.map(route.cruises, function (cruise) {
            cruise.datesDisplay = cruise.start + " bis " + cruise.end;
            airportIDs.push(cruise.airports);
            shipNames.push(cruise.ship);
            return cruise;
        });
        route.cruises = lodash_1.sortBy(route.cruises, function (cruise) {
            return moment_1.utc(cruise.start, 'DD.MM.YYYY').unix();
        });
        if (route.startHabour === route.endHabour) {
            route.description = route.duration + " Tage ab/bis " + route.startHabour;
        }
        else {
            route.description = route.duration + " Tage von " + route.startHabour + " nach " + route.endHabour;
        }
        route.images = lodash_1.take(lodash_1.compact(lodash_1.concat(route.routeMap, route.portImages, route.portImages, route.portImages, route.portImages)), 4);
        regionIDs.push(route.regionIDs);
        durationDays.push(route.duration);
    });
    state.searchResults = deepFreeze(lodash_1.cloneDeep(routes));
}
exports.SET_RESULTS = SET_RESULTS;
function SET_AIRPORT_INFO(state, airports) {
    state.availableAirports = airports;
}
exports.SET_AIRPORT_INFO = SET_AIRPORT_INFO;
function SET_FLIGHT_PRICES(state, params) {
    state.flights = (_a = {}, _a[params.airportCode] = params.flights, _a);
    var _a;
}
exports.SET_FLIGHT_PRICES = SET_FLIGHT_PRICES;
function FREEZE(state) {
    state.searchResults = deepFreeze(JSON.parse(JSON.stringify(state.searchResults)));
}
exports.FREEZE = FREEZE;
function REMOVE_RESULTS(state) {
    state.searchResults = [];
}
exports.REMOVE_RESULTS = REMOVE_RESULTS;
function TRIM_RESULTS(state, results) {
    state.searchResults = results;
}
exports.TRIM_RESULTS = TRIM_RESULTS;
function SET_REDUCED_RESULTS(state, filter) {
    state.reducedResultsFilter = filter;
}
exports.SET_REDUCED_RESULTS = SET_REDUCED_RESULTS;
// export everything compliant to the vuex specification for getters
exports.default = {
    PARAMS_TOUCHED: PARAMS_TOUCHED,
    SEARCH_BUTTON_TOUCHED: SEARCH_BUTTON_TOUCHED,
    SET_BACKGROUND_IMAGES: SET_BACKGROUND_IMAGES,
    SET_REGIONS: SET_REGIONS,
    SET_SHIP_LIST: SET_SHIP_LIST,
    SET_PARAM: SET_PARAM,
    SET_RESULTS: SET_RESULTS,
    SET_AIRPORT_INFO: SET_AIRPORT_INFO,
    SET_FLIGHT_PRICES: SET_FLIGHT_PRICES,
    FREEZE: FREEZE,
    REMOVE_RESULTS: REMOVE_RESULTS,
    TRIM_RESULTS: TRIM_RESULTS,
    SET_REDUCED_RESULTS: SET_REDUCED_RESULTS,
};
function deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function (prop) {
        if (o.hasOwnProperty(prop) &&
            o[prop] !== null &&
            (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
            !Object.isFrozen(o[prop])) {
            deepFreeze(o[prop]);
        }
    });
    return o;
}
//# sourceMappingURL=mutations.js.map